import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/calendarDetail/subscribeCalendar.svg';
const SubscribeCalendarSvg = () => React.createElement(IconSvg, null);
export default SubscribeCalendarSvg;
